import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { SalesTarget } from "../../../../components/modules/sales/sales-target";
import SalesTargetMiddleware from "../../../../middleware/modules/sales/sales-target";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
import IndexAssign from "../../../../components/modules/sales/sales-target/index-assign";
import TargetAssignmentMiddleware from "../../../../middleware/modules/sales/target-assignment";
// middlewares
const mapStateToProps = ({ auth, salesTarget,targetAssignment }) => ({
  isProcessing: salesTarget.isProcessing,
  isError: salesTarget.isError,
  errorMessage: salesTarget.errorMessage,
  dataAsign: salesTarget.dataAssign,
  showModal: salesTarget.showModal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => SalesTargetMiddleware.create(),
      reset: () => SalesTargetMiddleware.resetList(),
      search: (data) => SalesTargetMiddleware.listAssign(data),
      update: (data) => SalesTargetMiddleware.update(data),
      delete: (id, search) => SalesTargetMiddleware.beforeDelete(id, search),
      getHelperFull: (id, search) =>
        SalesTargetMiddleware.getHelperFull(id, search),
    },
    dispatch
  );
};
class IndexAssignContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.deleteItem = this.deleteItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  deleteItem(id, search) {
    this.props.delete(id, search);
  }
  updateItem(id) {
    this.props.getHelperFull();
    this.props.update(id);
  }
  createItem() {
    this.props.create();
    this.props.getHelperFull();
  }
  render() {
    const { isProcessing, search, dataAsign, showModal } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Sales Target List")}
          </title>
        </Helmet>
      <IndexAssign
        search={search}
        dataAssign={dataAsign}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IndexAssignContainer);
